import { UsernameModal } from './UsernameModal'
import { Activity, Component, SubmissionType } from '@cms-max/medicare-api-sdk'
import { useUpdateAccountHandler } from 'hooks/useUpdateAccountHandler'
import { updateUser } from 'redux/reducers/users'
import { Dispatch } from 'react'
import { EditUsernameFormData } from 'models/forms/UsernameForm'
import { useModalCloseEvent } from 'components/MyDialog/useModalCloseEvent'

export type EditUsernameModalProps = {
  onClose: () => void
}

const transformFormDataToRequestData = (formData: EditUsernameFormData) => ({
  username: formData.username
})

const handleSuccessfulUpdate = (dispatch: Dispatch<any>, formData: EditUsernameFormData) => {
  dispatch(updateUser({ username: formData.username }))
}

export const EditUsernameModal = ({ onClose }: EditUsernameModalProps) => {
  const trackSLSActivity = (respStatus: string) => {
    window.globalHeaderEvents?.handleEvent({
      core: {
        activity: Activity.DownstreamServiceResponse,
        component: Component.AccountSettings,
        property: 'MAX',
        elementId: 'accountsettings_username_response',
        additionalData: {
          result: respStatus
        },
        submissionType: SubmissionType.Update
      }
    })
  }

  const { handleSubmit, loading, serverErrors, password, user, setPassword } = useUpdateAccountHandler<EditUsernameFormData>(
    { onClose, trackSLSActivity, transformFormDataToRequestData, handleSuccessfulUpdate }
  )

  const handleEnterPassword = (password: string) => {
    // TODO: verify against API
    setPassword(password)
  }

  const handleClose = useModalCloseEvent('accountSettings', 'accountsettings_username_close', onClose)

  return user?.username
    ? (
    <UsernameModal
      loading={loading}
      onClose={handleClose}
      onSubmit={handleSubmit}
      onEnterPwd={handleEnterPassword}
      username={user.username}
      password={password}
      serverErrors={serverErrors}
    />
      )
    : null
}
